const inputCursorToEnd = (input) => {
  setTimeout(() => {
    input.setSelectionRange(input.value.length, input.value.length);
  });
};

export default inputCursorToEnd;
